import styled, { css } from 'styled-components';
import { isVertical } from '../utils';
import { TabOrientation } from '../tab-types';

interface ITabWrapperProps {
    tabOrientation: TabOrientation;
}

const verticalOrientationStyles = css`
    height: 100%;
`;

export const TabPanelWrapper = styled.div.attrs(() => ({
    className: String('ap-tabsPanel-wrapper')
})) <ITabWrapperProps>`
    width: 100%;
    ${({ tabOrientation }) => isVertical(tabOrientation) && verticalOrientationStyles}
    position: relative;
    box-sizing: border-box;
`;
